import { get, isEmpty } from 'lodash';

import { BEGIN_AJAX_CALL, END_AJAX_CALL } from '../common/actionType';
import {
  ATTEMPT_LOGIN_SUCCESS,
  BRAND_GUEST_LOGIN_SUCCESS,
  CLEAR_GUEST_DATA,
  CREATE_BRAND_GUEST,
  DISPATCH_AUTH_TOKEN,
  DISPATCH_BRAND_CONSENT_CONFIG,
  DISPATCH_CACHE_LOGIN_DATA,
  DISPATCH_GUEST_DATA,
  DISPATCH_SIGNIN_DATA,
  SET_IS_GUEST_MODE,
} from './actionType';
import {
  addBrandGuestApi,
  addFudrGuestApi,
  attemptLoginApi,
  findGuestByPhoneNumberApi,
  getGuestByIdApi,
  getUserProfileDataApi,
  sendOtpApi,
  updateProfileApi,
  signInByTrueCallerApi,
  sendOtpV2Api,
  verifyOtpV2Api,
  signInV2Api,
  updateUserConsentApi,
  getUserConsentApi,
  getBrandConsentConfigApi,
} from '../../api/api';
import { apiErrorResponseAction, beginAjaxCallAction, endAjaxCallAction } from '../common';
import {
  CLEAR_SELECTED_ADDRESS,
  FETCH_GUEST_ORDERS,
  FETCH_VIEW_CART,
  UPDATE_GUEST_ADDRESSES,
} from '../ordering/actionType';
import { DISPATCH_COMMUNITY_CONTEXT } from '../common/actionType';
import { storageTypes } from '../../constants/globals';
import {
  CLEAR_GUEST_CASH_CARDS,
  CLEAR_VERIFIED_LOCALITY,
  DISPATCH_REQUESTED_ASSISTANCES_TIMESTAMP,
} from '../actionType';
import {
  EMPTY_REWARD_GUEST_DETAILS,
  FETCH_GUEST_LAST_ORDER,
  FETCH_REFERRAL_CODE,
  UPDATE_GUEST_COUPON_FILTER,
} from '../rewards/actionType';
import { clearGuestPreviousOrderedItemsAction } from '../ordering';
import { getItem } from '../../utils/storage';
import { isNativeWebView } from '../../utils/helpers';

export const dispatchGuestDataAction = (guestData) => async (dispatch) => {
  dispatch({
    type: DISPATCH_GUEST_DATA,
    guestData,
  });
};

export const clearGuestDataAction = () => async (dispatch) => {
  dispatch({
    type: CLEAR_GUEST_DATA,
  });
};

export const dispatchSignInDataAction = (signIn) => async (dispatch) => {
  dispatch({
    type: DISPATCH_SIGNIN_DATA,
    signIn,
  });
};

export const attemptLoginAction = (loginReqBody) => async (dispatch) => {
  let loginData = {};
  try {
    dispatch({
      type: BEGIN_AJAX_CALL,
      showSpinner: true,
    });
    const loginDataResponse = await attemptLoginApi(loginReqBody)
      .then((response) => {
        loginData = get(response, 'data', {});
        localStorage.setItem('GuestLoginData', JSON.stringify(get(loginData, 'guest', {})));
        localStorage.setItem('AuthData', JSON.stringify(get(loginData, 'auth', {})));

        dispatch({
          type: ATTEMPT_LOGIN_SUCCESS,
          loginData: get(loginData, 'guest', {}),
        });
        dispatch({
          type: DISPATCH_AUTH_TOKEN,
          authData: get(loginData, 'auth', {}),
        });
        dispatch(dispatchGuestDataAction(get(loginData, 'guest', {})));
        return response;
      })
      .catch((errorResponse) => {
        const responseData = {
          ...get(errorResponse, 'response.data', {}),
        };
        const responseStatus = get(errorResponse, 'response.status', '');
        if (responseStatus) {
          responseData['statusCode'] = responseStatus;
        }
        // dispatch status code in the errorResponse
        dispatch(apiErrorResponseAction(responseData));
        return get(errorResponse, 'response', {});
      });
    return loginDataResponse;
  } catch (err) {
  } finally {
    dispatch({
      type: END_AJAX_CALL,
      showSpinner: false,
    });
  }
};

export const updateProfileAction = (updateProfileReqBody, guestId) => async (dispatch) => {
  try {
    dispatch({
      type: BEGIN_AJAX_CALL,
      showSpinner: true,
    });
    const updateProfileData = await updateProfileApi({
      updateProfileReqBody,
      guestId,
    })
      .then((response) => {
        localStorage.setItem('GuestLoginData', JSON.stringify(get(response, 'data', {})));
        dispatch({
          type: ATTEMPT_LOGIN_SUCCESS,
          loginData: get(response, 'data', {}),
        });
        dispatch(dispatchGuestDataAction(get(response, 'data', {})));
        return response;
      })
      .catch((errorResponse) => {
        return get(errorResponse, 'response.data', {});
      });
    return updateProfileData;
  } catch (err) {
  } finally {
    dispatch({
      type: END_AJAX_CALL,
      showSpinner: false,
    });
  }
};

export const getUserProfileDataAction = (guestId) => async (dispatch) => {
  let userProfileData = {};
  try {
    dispatch({
      type: BEGIN_AJAX_CALL,
      showSpinner: true,
    });
    userProfileData = await getUserProfileDataApi({ guestId });
    localStorage.setItem('GuestLoginData', JSON.stringify(get(userProfileData, 'data', {})));
    dispatch({
      type: ATTEMPT_LOGIN_SUCCESS,
      loginData: get(userProfileData, 'data', {}),
    });
  } catch (err) {
  } finally {
    dispatch({
      type: END_AJAX_CALL,
      showSpinner: false,
    });
  }
};

export const getGuestByIdAction =
  ({ guestId, sendEventToNative }) =>
  async (dispatch) => {
    let guestData = {};
    try {
      guestData = await getGuestByIdApi({ guestId });
      localStorage.setItem('GuestLoginData', JSON.stringify(guestData));
      const authData = getItem(storageTypes.localStorage, 'AuthData');

      dispatch({
        type: ATTEMPT_LOGIN_SUCCESS,
        loginData: guestData,
      });
      dispatch({
        type: DISPATCH_AUTH_TOKEN,
        authData: authData,
      });

      if (isNativeWebView && sendEventToNative) {
        const dataToSend = { guest: guestData, auth: authData };
        const data = {
          eventType: { type: 'loginData', data: dataToSend },
        };
        window.ReactNativeWebView.postMessage(JSON.stringify(data));
      }
      dispatch(dispatchGuestDataAction(guestData));
    } catch (err) {
      console.log(err);
    }
  };

export const dispatchGuestLoginDataAction = (guestLoginData) => async (dispatch) => {
  localStorage.setItem('GuestLoginData', JSON.stringify(get(guestLoginData, 'guest', {})));
  localStorage.setItem('AuthData', JSON.stringify(get(guestLoginData, 'auth', {})));
  dispatch({
    type: ATTEMPT_LOGIN_SUCCESS,
    loginData: get(guestLoginData, 'guest', {}),
  });
  dispatch({
    type: DISPATCH_AUTH_TOKEN,
    authData: get(guestLoginData, 'auth', {}),
  });
};

export const dispatchLogoutAction = () => (dispatch) => {
  try {
    if (isNativeWebView) {
      const data = {
        eventType: { type: 'logout' },
      };
      window.ReactNativeWebView.postMessage(JSON.stringify(data));
    }
    dispatch({
      type: BEGIN_AJAX_CALL,
      showSpinner: true,
    });
    localStorage.setItem('GuestLoginData', JSON.stringify({}));
    localStorage.setItem('BrandGuestData', JSON.stringify({}));
    localStorage.setItem('AuthData', JSON.stringify({}));
    dispatch({
      type: ATTEMPT_LOGIN_SUCCESS,
      loginData: {},
    });
    dispatch({
      type: BRAND_GUEST_LOGIN_SUCCESS,
      brandGuestLoginData: {},
    });
    dispatch({
      type: FETCH_GUEST_LAST_ORDER,
      guestLastOrder: {},
    });
    dispatch({
      type: DISPATCH_AUTH_TOKEN,
      authData: {},
    });
    dispatch({
      type: DISPATCH_REQUESTED_ASSISTANCES_TIMESTAMP,
      requestedAssistancesTimeStampArr: [],
    });
    dispatch({
      type: FETCH_GUEST_ORDERS,
      guestOrders: {},
    });
    dispatch({
      type: EMPTY_REWARD_GUEST_DETAILS,
    });
    dispatch({
      type: FETCH_REFERRAL_CODE,
      referralCode: null,
    });
    // Clear guest cash card list
    dispatch({
      type: CLEAR_GUEST_CASH_CARDS,
    });
    dispatch({ type: CLEAR_VERIFIED_LOCALITY });
    dispatch(clearGuestDataAction());
    // Clear the guest's previous orders list
    dispatch(clearGuestPreviousOrderedItemsAction());
    //clear the reward history
    dispatch({ type: UPDATE_GUEST_COUPON_FILTER, filter: {} });
    // empty cart
    dispatch({
      type: FETCH_VIEW_CART,
      items: {},
    });
    // Keep selectedTable / restaurant so the guest's outlet selection survives logout.
    dispatch({
      type: CLEAR_SELECTED_ADDRESS,
    });
    dispatch({
      type: UPDATE_GUEST_ADDRESSES,
      guestAddresses: [],
    });
    // Drop persisted community / address context so the next user does not see the prior guest's location.
    dispatch({
      type: DISPATCH_COMMUNITY_CONTEXT,
      communityContext: {
        orderContext: '',
        community: {},
        slot: {},
        selectedAddress: {},
      },
    });
    // Return to guest browsing so public Site routes (About Us, etc.) work without re-auth.
    dispatch({
      type: SET_IS_GUEST_MODE,
      isGuestMode: true,
    });
  } catch (err) {
    console.error(err);
  } finally {
    dispatch({
      type: END_AJAX_CALL,
      showSpinner: false,
    });
  }
};

export const findGuestByPhoneNumberAction = (phoneNumber) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const findGuestByPhoneNumberAPIResponse = await findGuestByPhoneNumberApi({
      phoneNumber,
    })
      .then((response) => {
        return response;
      })
      .catch((errorResponse) => {
        // dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });
    return findGuestByPhoneNumberAPIResponse;
  } catch (error) {
    console.error(error);
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const sendOtpAction = (phoneNumber, countryCode, res, brandId) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const sendOtpResponse = await sendOtpApi(phoneNumber, countryCode, res, brandId)
      .then((response) => {
        return response;
      })
      .catch((errorResponse) => {
        return get(errorResponse, 'response', {});
      });
    return sendOtpResponse;
  } catch (error) {
    console.error(error);
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const addFudrGuestAction =
  ({ signupReqBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const addFudrGuestAPIResponse = await addFudrGuestApi({
        signupReqBody,
      })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          return get(errorResponse, 'response', {});
        });
      return addFudrGuestAPIResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const addBrandGuestAction =
  ({ addBrandGuestReqBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const addBrandGuestAPIResponse = await addBrandGuestApi({
        addBrandGuestReqBody,
      })
        .then((response) => {
          dispatch({
            type: CREATE_BRAND_GUEST,
            brandGuest: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          return get(errorResponse, 'response', {});
        });
      return addBrandGuestAPIResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const signInByTrueCallerAction =
  ({ requestId }) =>
  async () => {
    const signInByTrueCallerResponse = await signInByTrueCallerApi({ requestId })
      .then((response) => {
        return response;
      })
      .catch((errorResponse) => {
        return get(errorResponse, 'response', {});
      });
    return signInByTrueCallerResponse;
  };

export const sendOtpV2Action = (reqBody) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const sendOtpResponse = await sendOtpV2Api(reqBody)
      .then((response) => {
        return response;
      })
      .catch((errorResponse) => {
        const responseData = {
          ...get(errorResponse, 'response.data', {}),
        };
        const responseStatus = get(errorResponse, 'response.status', '');
        if (responseStatus) {
          responseData['statusCode'] = responseStatus;
        }
        // dispatch status code in the errorResponse
        dispatch(apiErrorResponseAction(responseData));
        return get(errorResponse, 'response', {});
      });
    return sendOtpResponse;
  } catch (error) {
    console.error(error);
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const verifyOtpV2Action = (reqBody) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const sendOtpResponse = await verifyOtpV2Api(reqBody)
      .then((response) => {
        return response;
      })
      .catch((errorResponse) => {
        const responseData = {
          ...get(errorResponse, 'response.data', {}),
        };
        const responseStatus = get(errorResponse, 'response.status', '');
        if (responseStatus) {
          responseData['statusCode'] = responseStatus;
        }
        // dispatch status code in the errorResponse
        dispatch(apiErrorResponseAction(responseData));
        return get(errorResponse, 'response', {});
      });
    return sendOtpResponse;
  } catch (error) {
    console.error(error);
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const signInV2Action = (reqBody) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const signInResponse = await signInV2Api(reqBody)
      .then((response) => {
        return response;
      })
      .catch((errorResponse) => {
        const responseData = {
          ...get(errorResponse, 'response.data', {}),
        };
        const responseStatus = get(errorResponse, 'response.status', '');
        if (responseStatus) {
          responseData['statusCode'] = responseStatus;
        }
        // dispatch status code in the errorResponse
        dispatch(apiErrorResponseAction(responseData));
        return get(errorResponse, 'response', {});
      });
    return signInResponse;
  } catch (error) {
    console.error(error);
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const dispatchSignInV2Action = (response) => async (dispatch) => {
  try {
    const loginData = get(response, 'data', {});

    localStorage.setItem('BrandGuestData', JSON.stringify(get(loginData, 'brandGuest', {})));
    localStorage.setItem('AuthData', JSON.stringify(get(loginData, 'auth', {})));

    if (isNativeWebView) {
      const dataToSend = { ...loginData, brandGuest: get(loginData, 'brandGuest', {}) };
      const data = {
        eventType: { type: 'loginData', data: dataToSend },
      };
      window.ReactNativeWebView.postMessage(JSON.stringify(data));
    }

    dispatch({
      type: DISPATCH_AUTH_TOKEN,
      authData: get(loginData, 'auth', {}),
    });
  } catch (error) {
    console.error(error);
  }
};

export const dispatchBrandGuestLoginDataAction =
  ({ brandGuest, authData }) =>
  async (dispatch) => {
    dispatch({
      type: BRAND_GUEST_LOGIN_SUCCESS,
      brandGuestLoginData: brandGuest,
    });

    // Site/ordering often start in guest mode; clear it as soon as a real guest session exists
    // so loyalty mini card and other guest-gated UI switch to the logged-in state.
    if (!isEmpty(get(brandGuest, 'id'))) {
      dispatch({
        type: SET_IS_GUEST_MODE,
        isGuestMode: false,
      });
    }

    if (!isEmpty(authData)) {
      dispatch({
        type: DISPATCH_AUTH_TOKEN,
        authData,
      });
    }
  };
export const setIsGuestModeAction = (isGuestMode) => (dispatch) => {
  dispatch({
    type: SET_IS_GUEST_MODE,
    isGuestMode,
  });
};

export const updateUserConsentAction =
  ({ brandGuestId, requestBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const updateUserConsentResponse = await updateUserConsentApi({ brandGuestId, requestBody })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          const responseData = {
            ...get(errorResponse, 'response.data', {}),
          };
          const responseStatus = get(errorResponse, 'response.status', '');
          if (responseStatus) {
            responseData['statusCode'] = responseStatus;
          }
          // dispatch status code in the errorResponse
          dispatch(apiErrorResponseAction(responseData));
          return get(errorResponse, 'response', {});
        });
      return updateUserConsentResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const getUserConsentAction =
  ({ brandGuestId }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const getUserConsentResponse = await getUserConsentApi({ brandGuestId })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          const responseData = {
            ...get(errorResponse, 'response.data', {}),
          };
          const responseStatus = get(errorResponse, 'response.status', '');
          if (responseStatus) {
            responseData['statusCode'] = responseStatus;
          }
          // dispatch status code in the errorResponse
          dispatch(apiErrorResponseAction(responseData));
          return get(errorResponse, 'response', {});
        });
      return getUserConsentResponse;
    } catch (errorResponse) {
      const responseData = {
        ...get(errorResponse, 'response.data', {}),
      };
      const responseStatus = get(errorResponse, 'response.status', '');
      if (responseStatus) {
        responseData['statusCode'] = responseStatus;
      }
      // dispatch status code in the errorResponse
      dispatch(apiErrorResponseAction(responseData));
      return get(errorResponse, 'response', {});
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const getBrandConsentConfigAction = (brandId) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const getBrandConsentConfigResponse = await getBrandConsentConfigApi(brandId)
      .then((response) => {
        dispatch({
          type: DISPATCH_BRAND_CONSENT_CONFIG,
          brandConsentConfig: get(response, 'data.resource', {}),
        });
        return response;
      })
      .catch((errorResponse) => {
        return get(errorResponse, 'response', {});
      });
    return getBrandConsentConfigResponse;
  } catch (error) {
    console.error(error);
  } finally {
    dispatch(endAjaxCallAction());
  }
};
